import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {setUpStore, callAction} from 'client/framework';
import SearchDropdownStore from 'sg/Dropdowns/SearchDropdown/SearchDropdown.store';
import {resource} from '@albert-io/json-api-framework/request/builder';
import {StandardChip} from 'client/QuestionTypes/common/V2/StandardChip.react';

import {CheckboxChip, Text, Button, Icon} from '@albert-io/atomic';

import questionEditorActions from '../../EditPage/V2/QuestionEditor/QuestionEditor.actions';

import StandardSelectModal from './StandardSelectModal.react';

import './standard-search.scss';

export default class StandardSearch extends React.Component {
  static propTypes = {
    subjectId: PropTypes.string,
    standards: ImmutablePropTypes.list,
    disabled: PropTypes.bool
  };

  constructor() {
    super();
    this.state = {
      showAddStandardsModal: false
    };
  }

  getStore() {
    return setUpStore(SearchDropdownStore, 'StandardsSearchStoreName');
  }

  renderSearchResult = (option) => {
    return (
      <div>
        <Text bold>{option.getTitle()}</Text>
        <br />
        <small>{option.getDescription()}</small>
      </div>
    );
  };

  getSearchStandardsByNameQuery = (searchString) => {
    return resource('standards_v1')
      .mandarkEndpoint(['standards_v1'])
      .filter({
        standard_set_v1: {
          authoring_subjects_v1: this.props.subjectId
        }
      })
      .filter(
        {
          any_of: [
            {
              title: {
                case_insensitive_substring: searchString
              }
            }
          ]
        },
        Boolean(searchString)
      )
      .sort('title');
  };

  getOptions() {
    const searchString = this.getStore().getSearchString();
    return searchString && this.getSearchStandardsByNameQuery(searchString).isResourcePopulated()
      ? this.getSearchStandardsByNameQuery(searchString).getResource()
      : null;
  }

  areResultsLoading() {
    const searchString = this.getStore().getSearchString();
    return (
      searchString !== '' && !this.getSearchStandardsByNameQuery(searchString).isResourcePopulated()
    );
  }

  handleChipClick = (e, standardToRemove) => {
    // clicking on a chip only removes standards
    const filteredStandards = this.props.standards.filter(
      (standard) => standard.getId() !== standardToRemove.getId()
    );
    callAction(questionEditorActions.UPDATE_QUESTION_STANDARDS, filteredStandards);
  };

  getStandardsList() {
    return this.props.standards.map((standard) => {
      return (
        <StandardChip
          as={CheckboxChip}
          defaultChecked
          enableTooltip
          icon='tag'
          color='blue'
          key={standard.getId()}
          standard={standard}
          onChange={(e) => this.handleChipClick(e, standard)}
        />
      );
    });
  }

  render() {
    return (
      <div className='u-mar-t_6 u-mar-b_6'>
        <Text bold className='u-mar-r_1'>
          Standards
        </Text>
        <Button
          size='s'
          variant='outlined'
          disabled={this.props.disabled}
          onClick={() => this.setState({showAddStandardsModal: true})}
        >
          Add
          <Icon className='u-mar-l_1' icon='plus' />
        </Button>
        {this.props.disabled ? 'Please save the question before adding standards.' : null}
        <div className='standard-search__standard-list'>{this.getStandardsList()}</div>
        {this.state.showAddStandardsModal && (
          <StandardSelectModal
            onDismiss={() => this.setState({showAddStandardsModal: false})}
            query={this.getSearchStandardsByNameQuery}
            standards={this.props.standards}
          />
        )}
      </div>
    );
  }
}
